










































































































































import {computed, defineComponent, PropType, ref} from "@vue/composition-api";
import ProjectToolbarMenu from "@tool/Pages/App/Project/partials/ProjectToolbarMenu.vue";
import useAppStore from "@tool/store/useAppStore";
import {ProjectEntityInterface} from "@tool/tool.types";
import moment from "moment";
import useInertiaData from "@tool/Helpers/useInertiaData";

export default defineComponent({
    components: {
        ProjectToolbarMenu,
    },

    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: false
        }
    },
    setup() {

        const showingNavigationDropdown = ref(false);

        const inertiaData = useInertiaData();
        const user = inertiaData.value.user;
        const billing_trial_ends_at = inertiaData.value.billing_trial_ends_at;

        const {loadingOverlay} = useAppStore();

        const trialMessage = computed(() => {
            if (!billing_trial_ends_at) {
                return null;
            }

            const dayDiff = moment(billing_trial_ends_at).diff(moment(), 'd');

            if (dayDiff < 0) {
                return `You free trial expired. Subscribe now to unlock all features!`
            }

            return `You have ${dayDiff} days left on your free trial. Subscribe now!`
        })

        return {showingNavigationDropdown, trialMessage, loadingOverlay, user};

    }
})
